"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var react_parallax_1 = require("react-parallax");

require("./style.scss");

var insideStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)'
};
/**
 * General Parallax image.
 */

var ParallaxImage = function ParallaxImage(_a) {
  var children = _a.children,
      color = _a.color,
      src = _a.src;
  return react_1.default.createElement(react_parallax_1.Parallax, {
    bgImage: src,
    strength: 200,
    renderLayer: function renderLayer(percentage) {
      return react_1.default.createElement("div", {
        style: {
          background: color,
          filter: "grayscale(" + (1 - percentage) + ")",
          height: '100%',
          opacity: "" + (1 - percentage),
          position: 'absolute',
          width: '100%'
        }
      });
    }
  }, react_1.default.createElement("div", {
    style: {
      height: 500
    }
  }, react_1.default.createElement("div", {
    style: insideStyles
  }, children)));
};

ParallaxImage.propTypes = {
  /** Determines the overlay `Image` */
  children: prop_types_1.default.element,

  /** Determines the background overlay color of the `Image` */
  color: prop_types_1.default.string,

  /** Destination URL of the image file. */
  src: prop_types_1.default.string
};
ParallaxImage.defaultProps = {
  children: undefined,
  color: undefined,
  src: undefined
};
exports.default = ParallaxImage;